<app-modal-box>
  <div modal-header class="header">
    <h4>Start your Rain Trivia</h4>
    <p>Enter the amount, your question and answers</p>
  </div>
  <div class="content">
    <form [formGroup]="triviaRainForm" (ngSubmit)="startTriviaRain()">
      <div class="input-group-title">
        <p class="input-title">Amount</p>
        <div class="input-group">
          <input required formControlName="amount" type="number" placeholder="Enter amount" />
        </div>
      </div>
      <div style="margin-top: -0.5rem" class="input-group-title">
        <p class="input-title">Question</p>
        <div class="input-group">
          <input required formControlName="triviaQuestion" type="text" placeholder="Enter your question" />
        </div>
      </div>
      <span class="divider"></span>
      <div class="input-group input-style-green">
        <input required formControlName="triviaAnswer" type="text" placeholder="Enter Correct Answer" />
      </div>
      <div class="input-group">
        <input formControlName="triviaIncorrect1" type="text" placeholder="Enter Incorrect Answer #1" />
        <!-- <span class="label">(optional)</span> -->
      </div>
      <div class="input-group">
        <input formControlName="triviaIncorrect2" type="text" placeholder="Enter Incorrect Answer #2" />
        <!-- <span class="label">(optional)</span> -->
      </div>
      <div class="input-group">
        <input formControlName="triviaIncorrect3" type="text" placeholder="Enter Incorrect Answer #3" />
        <!-- <span class="label">(optional)</span> -->
      </div>
      <button type="submit" class="button red large" [class.disabled]="triviaRainForm.invalid">Start trivia</button>
    </form>
    <p class="warning">
      Pleave verify the questions and the answer, make sure there are no typos before hosting a trivia. Anyone can host their own trivia with a custom question (random questions
      soon). Whoever gets the answer right, split the prize with everyone who answered correctly.
    </p>
    <p class="warning-red">Make sure you follow the strict rules or you'll be permanently banned from hosting or particapting in these trivias.</p>
  </div>
</app-modal-box>
